import React, { useEffect, useState } from 'react';

// material-ui
import { Grid, Typography, Box, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';

// assets
import useLeagues from 'hooks/useLeagues';
import LeagueStatsTable from './LeagueStatsTable';
import capitalizeWords from 'utils/capitalizeWords';

const LeagueStats = ({ leagueId, type = 'league' }) => {
    const { getLeagueStats, getLeagueEventList, isLoading } = useLeagues();
    const [selectedEventInstance, setSelectedEventInstance] = useState('all');
    const [eventInstances, setEventInstances] = useState([]);

    useEffect(() => {
        getLeagueStats(leagueId);
        // Fetch event instances for the dropdown
        if (leagueId) {
            getLeagueEventList(leagueId, type).then((instances) => {
                console.log('instances', instances);
                setEventInstances(instances || []);
            });
        }
    }, [leagueId]);

    const handleEventInstanceChange = (event) => {
        const value = event.target.value;
        setSelectedEventInstance(value);

        if (value === 'all') {
            getLeagueStats(leagueId);
        } else {
            getLeagueStats(leagueId, value);
        }
    };

    return (
        <MainCard
            title={
                <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Typography variant="h3">{capitalizeWords(type)} Stats</Typography>
                            <Grid ml={3}>
                                <FormControl size="small" sx={{ minWidth: 120 }}>
                                    <InputLabel>Time Period</InputLabel>
                                    <Select value={selectedEventInstance} label="Time Period" onChange={handleEventInstanceChange}>
                                        <MenuItem value="all">All Time</MenuItem>
                                        {eventInstances.map((instance) => (
                                            <MenuItem key={instance.id} value={instance?.id}>
                                                {instance?.title}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
            content={false}
        >
            {isLoading ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
                    <CircularProgress />
                </Box>
            ) : (
                <LeagueStatsTable />
            )}
        </MainCard>
    );
};

export default LeagueStats;
